
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useLanguage } from "@/contexts/LanguageContext";
import ironHangar from "@/assets/iron-hangar.jpg";
import ironShade from "@/assets/iron-shade.jpg";
import ironStairs from "@/assets/iron-stairs.jpg";
import ironRailing from "@/assets/iron-railing.jpg";

const Iron = () => {
  const { language, isRTL } = useLanguage();

  const productSlugs = ["hangars", "shades", "stairs", "railings"];

  const content = {
    ar: {
      title: "منتجات الحديد",
      viewDetails: "عرض التفاصيل",
      products: [
        { title: "هناجر", description: "هناجر بمختلف المقاسات والتصميمات" },
        { title: "مظلات", description: "مظلات بتصميمات عصرية ومتينة" },
        { title: "سلالم حديد", description: "سلالم حديد بتصميمات مبتكرة" },
        { title: "درابزينات", description: "درابزينات حديد بتصميمات أنيقة" }
      ]
    },
    en: {
      title: "Iron Products",
      viewDetails: "View Details",
      products: [
        { title: "Hangars", description: "Hangars in various sizes and designs" },
        { title: "Shades", description: "Modern and durable shade structures" },
        { title: "Iron Stairs", description: "Innovative iron staircase designs" },
        { title: "Railings", description: "Elegant iron railing designs" }
      ]
    }
  };

  const t = content[language];
  const images = [ironHangar, ironShade, ironStairs, ironRailing];

  return (
    <div className="min-h-screen bg-gray-50 py-12" dir={isRTL ? "rtl" : "ltr"}>
      <Navbar />
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-kufi font-bold text-center mb-12 text-primary">{t.title}</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.products.map((product, index) => (
            <motion.div key={product.title} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: index * 0.1 }}>
              <Card className="overflow-hidden hover:shadow-lg transition-shadow duration-300 h-full flex flex-col">
                <img src={images[index]} alt={product.title} className="w-full h-48 object-cover" />
                <CardContent className="p-6 flex-grow flex flex-col">
                  <h3 className="text-xl font-kufi font-bold mb-2">{product.title}</h3>
                  <p className="text-gray-600 mb-4 flex-grow">{product.description}</p>
                  <Link to={`/iron/${productSlugs[index]}`}>
                    <Button className="bg-primary hover:bg-primary/90 w-full">{t.viewDetails}</Button>
                  </Link>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Iron;
